import styled from 'styled-components/macro';

export const StyledLoading = styled.div`
  width: 100%;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${({ height }: { height?: number | string }) => height || '100%'};
`;
